import React, { useEffect, useState } from "react";
import Styles from "../../Styles/CommomDashboard/Listing.module.css";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch, useSelector } from "react-redux";
import MyListCard from "./MyListCard";
import { ConsumerCapacityModal } from "../../pages/DashBoard/consumerCapacityModal";
import { PreviewModel } from "../../pages/DashBoard/previewModel";
import ListingModal from "../ListingCreateModal/ListingModal";
import { getSpeceficTraders, getSpeceficTradersNew } from "../../store/Analyst/action";

const Listing = ({
  getMatchingProfilesCon,
  getMatchingProfiles,
  setMatchingProfiles,
  selectedCardIndex,
  setSelectedCardIndex,
  setSelectedCardData,
  formResetFlag,
  setFormResetFlag,
  displayList,
}) => {
  const role = useSelector((state) => state?.sessionState?.role);
  const dispatch = useDispatch();
  const [isModel, setIsModel] = useState(false);

  useEffect(() => {
    if (displayList?.length > 0) {
      getSpeceficTradersNew(displayList?.[0]?.company?.companyId)(dispatch);
    }
  }, [displayList]);

  const handleAddNewSlot = (e) => {
    setIsModel(true);
  };

  const handleEditClick = (item) => {
    setIsModel(false);
  };

  const handleResetForm = () => {
    setFormResetFlag(!formResetFlag);
  };

  return (
    <>
      <div className={Styles.ListingContainer}>
        <div className={Styles.myListText}>My Listing</div>
        <div>
          <div className={Styles.listContainer}>
            <div className={Styles.layoutContainer01}>
              {displayList?.map((item, index) => (
                <MyListCard
                  key={index}
                  item={item}
                  getMatchingProfilesCon={getMatchingProfilesCon}
                  getMatchingProfiles={getMatchingProfiles}
                  selectedCardIndex={selectedCardIndex}
                  setSelectedCardIndex={setSelectedCardIndex}
                  setMatchingProfiles={setMatchingProfiles}
                  setSelectedCardData={setSelectedCardData}
                  handleResetForm={handleResetForm}
                />
              ))}
            </div>
            <div className={Styles.buttonCont}>
              <div onClick={handleAddNewSlot} className={Styles.addButton}>
                {/* <AddIcon style={{ fontSize: "20px", marginTop: "-2px", fontWeight:"900" }} /> */}
                <i className="fa fa-plus me-1"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {isModel && (
        <ListingModal open={isModel} handleClose={() => setIsModel(false)} />
      )} */}
      {isModel && role === "CONSUMER" && (
        <ConsumerCapacityModal
          isOpen={isModel}
          getMatchingProfilesCon={getMatchingProfilesCon}
          handleSubmit={handleEditClick}
        />
      )}
      {isModel && role === "GENERATOR" && (
        <PreviewModel isOpen={isModel} handleSubmit={handleEditClick} />
      )}
    </>
  );
};

export default Listing;
